/* eslint react-hooks/exhaustive-deps: "warn" */

import { useContext, useMemo } from 'react';

import { blog as blogTypes } from 'types';

import { useRouter } from 'libs/router/useRouter';

import { ContentContext } from 'context/ContentContext';

import { Section } from 'ui/molecules/Section/Section';
import { Tabs } from 'ui/atoms/Tabs/Tabs';

import { ArticleSearch } from 'features/articles/organisms/ArticleSearch/ArticleSearch';
import { Benefits } from 'features/articles/organisms/Benefits/Benefits';

import styles from './BlogPage.module.scss';

const BlogPage = () => {
  const { query } = useRouter();
  const { secondaryNavigation, pageVars } = useContext(ContentContext);

  const commonPageVars = useMemo(() => pageVars.common || {}, [pageVars.common]);

  const blog = useMemo(() => blogTypes.filter((type) => commonPageVars[`blog_${type}`]), [commonPageVars]);

  const blogSlug = secondaryNavigation?.blog?.slug || 'blog';

  const tabs = useMemo(
    () => [
      ...(commonPageVars.blog_all ? [{ key: '', label: commonPageVars.blog_all, route: blogSlug }] : []),
      ...blog.map((type) => ({ key: type, label: commonPageVars[`blog_${type}`], route: blogSlug, query: { type } })),
    ],
    [blog, commonPageVars, blogSlug],
  );

  const activeKey = useMemo(() => `${query.type || ''}`, [query.type]);

  return (
    <Section title={commonPageVars.blog_title}>
      <div className={styles.blogHeaderNav}>
        <ArticleSearch variant="pill" className={styles.blogSearch} />

        <Tabs tabs={tabs} activeKey={activeKey} size="xl" variant="underline" scrollable />
      </div>

      <Benefits hasPriortyFirstImage className={styles.blogPageBenefits} withBlog />
    </Section>
  );
};

// eslint-disable-next-line import/no-default-export
export default BlogPage;
